import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
const DownloadLink = ({ fileIcon, fileName, fileLink, label }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: "download-file-link", children: [_jsxs("div", { className: "file-name", children: [fileIcon, _jsx("p", { children: fileName })] }), _jsx("div", { className: "download-link", children: _jsx("a", { className: "link-button", href: fileLink, download: true, children: label ? label : t('button.download') }) })] }));
};
export default DownloadLink;
